import { useEffect, useState } from "react"
import { MaintenanceState, probeMaintenance } from "../../api/maintenance"

// the light wordmark the login app and the guest purchase page show
const LOGO_URL = "https://downloads.newfangledaudio.com/nfa/images/logo-long-light.png"

// What the whole app becomes while the backend is closed for maintenance
// (src/api/maintenance.ts): the message the switch carries, and a poll of
// the API at the interval its 503s advised — the page reloads itself the
// moment the system is open again, so nothing stale survives the window.
// Rendered outside the shell: there is no session-dependent state worth
// keeping around.
export default function MaintenancePage({ maintenance, accessToken }: { maintenance: MaintenanceState, accessToken?: string }) {
  const [checking, setChecking] = useState(false)
  const [lastChecked, setLastChecked] = useState<Date | null>(null)

  const check = async () => {
    setChecking(true)
    const open = await probeMaintenance(accessToken)
    if (open) {
      window.location.reload()
      return
    }
    setLastChecked(new Date())
    setChecking(false)
  }

  useEffect(() => {
    const timer = setInterval(() => { void check() }, maintenance.retryAfterSecs * 1000)
    const onWake = () => { if (document.visibilityState === "visible") void check() }
    document.addEventListener("visibilitychange", onWake)
    window.addEventListener("online", onWake)
    return () => {
      clearInterval(timer)
      document.removeEventListener("visibilitychange", onWake)
      window.removeEventListener("online", onWake)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maintenance.retryAfterSecs, accessToken])

  return (
    <div className="maintenance-shell">
      <img src={LOGO_URL} alt="Newfangled Audio" className="guest-purchase-logo" width={3000} height={301} />
      <div className="card maintenance-card">
        <div className="card-title">Closed for maintenance</div>
        <div className="card-detail">
          {maintenance.message ?? "We're doing some work on our systems and will be back shortly."}
        </div>
        <div className="card-detail maintenance-detail">
          Your licenses and installed plug-ins keep working. This page checks back on its own and reloads
          once we're open again.
        </div>
        <div className="card-links">
          <button className="card-link" onClick={() => { void check() }} disabled={checking}>
            {checking ? "Checking…" : "Check now"}
          </button>
          {lastChecked !== null && (
            <span className="maintenance-checked">Last checked {lastChecked.toLocaleTimeString()}</span>
          )}
        </div>
      </div>
    </div>
  )
}
